/**
 * Named code chunks a screen can ask to start downloading before they are needed.
 *
 * 🔴 A REGISTRY, SO THE ASKER NEVER IMPORTS THE CHUNK. The teacher's play dialog
 * wants the child's app warm before the laptop changes hands, but a static
 * import of `KidApp` from a console screen would put three.js and every round
 * straight back into the bundle the lazy split took them out of. The router
 * registers the loader it already uses; anything else only names it.
 */
const loaders = new Map<string, () => Promise<unknown>>()

export function registerChunk(name: string, load: () => Promise<unknown>): void {
  loaders.set(name, load)
}

/** Starts the download if the chunk is registered; silent either way. */
export function prefetchChunk(name: string): void {
  const load = loaders.get(name)
  if (!load) return
  load().catch(() => {
    /* Offline or a stale deploy — the real import will try again and report it. */
  })
}
